import React from 'react';
import { Helmet } from 'react-helmet';
import { Box, Typography, Container } from '@mui/material';
import { useLocation } from 'react-router-dom';
import { getCanonicalUrl } from '../utils/canonicalUrl';

export default function Privacy() {
  const location = useLocation();
  const canonicalUrl = getCanonicalUrl(location.pathname);
  return (
    <Box sx={{ color: 'common.white' }}>
      <Helmet>
        <link rel="canonical" href={canonicalUrl} />
        <title>Privacy & Cookies</title>
        <meta name="description" content="Read our privacy and cookie policies." />
        <meta property="og:title" content="Privacy & Cookies" />
        <meta property="og:description" content="How Robinson Engineering handles your data and cookies." />
        <meta property="og:image" content="/assets/visuals/re-profile-blue-ai-hud.webp" />
      </Helmet>
      <Box
        sx={{
          position: 'relative',
          backgroundImage:
            'linear-gradient(rgba(24,45,70,0.8), rgba(53,85,111,0.8)), url("/assets/visuals/re-profile-blue-ai-hud.webp")',
          backgroundSize: 'cover',
          backgroundPosition: 'center',
          textAlign: 'center',
          py: { xs: 8, md: 12 },
        }}
      >
        <Container>
          <Typography variant="h2" component="h1" gutterBottom>
            Privacy &amp; Cookies
          </Typography>
        </Container>
      </Box>
      <Typography paragraph>
        Robinson Engineering respects your privacy. We only collect personal information that you voluntarily provide, such as details you submit when requesting our services.
      </Typography>
      <Typography paragraph>
        This information is used solely to respond to enquiries, deliver our services and improve this website. We never sell your data to third parties.
      </Typography>
      <Typography paragraph>
        Our site uses minimal cookies for analytics and to remember preferences. By continuing to browse you consent to this use of cookies.
      </Typography>
    </Box>
  );
}
